require("!!/home/login/Documents/Jijifest/A4TCorev2AdminUi/node_modules/script-loader/addScript.js")(require("!!/home/login/Documents/Jijifest/A4TCorev2AdminUi/node_modules/raw-loader/index.js!/home/login/Documents/Jijifest/A4TCorev2AdminUi/node_modules/handsontable/dist/handsontable.full.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/handsontable/dist/handsontable.full.js
// module id = 590
// module chunks = 11